export default __webpack_public_path__ + "static/media/growth-1.40c4c833.jpg";